var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', [_c('sub-visual', {
    attrs: {
      "sh": "Distributor in Korea",
      "tabActive": "Mitsubishi O-Ring",
      "bg": "/images/sub/visual/sv3.png"
    }
  }), _c('section', {
    staticClass: "sub-section sub-section--first"
  }, [_c('v-container', [_c('h2', {
    staticClass: "page-tit mb-lg-42"
  }, [_vm._v(" Mitsubishi O-Ring ")])]), _c('sub-bg-image', {
    attrs: {
      "src": "/images/sub/distributor/oring/oring-top-img.png",
      "className": "h-lg-280px"
    }
  }, [_c('h3', {
    staticClass: "tit font-weight-semibold mb-8 mb-md-50 mb-lg-100"
  }, [_vm._v(" MITSUBISHI CABLE 은 1917년 창립한 "), _c('br'), _vm._v(" 약 100년 역사를 가진 일본 회사 입니다. ")]), _c('p', {
    staticClass: "page-text color-grey-51 mb-2 mb-lg-10"
  }, [_vm._v(" 고무 O-Ring 제품은 일본 방위성에서 요청에 의해서 "), _c('br', {
    staticClass: "d-none d-md-block"
  }), _vm._v(" 1958년 부터 생산 하고 있습니다. ")]), _c('p', {
    staticClass: "page-text color-grey-51"
  }, [_vm._v(" 오랜 경험을 통해 얻은 노하우를 통해 핵심 역량인 "), _c('br', {
    staticClass: "d-none d-md-block"
  }), _vm._v(" ‘재료 복합 기술’ , ‘설계기술‘ , ‘생산 엔지니어링’에 근거한 "), _c('br', {
    staticClass: "d-none d-md-block"
  }), _vm._v(" 획기적인 솔루션을 넓히고 있습니다. ")])])], 1), _c('section', {
    staticClass: "sub-section"
  }, [_c('v-container', [_c('sub-line-layout', {
    attrs: {
      "tit": "특장점"
    }
  }, [_c('p', {
    staticClass: "page-text color-grey-51 mb-30 mb-lg-52"
  }, [_vm._v(" 다양한 업계로부터 많은 추천과 관심을 받고 있습니다. "), _c('br'), _vm._v(" 기기 설계 단계에서 요구하시는 O-Ring 에 대한 문의를 항상 환영하고 있습니다. ")]), _c('v-row', [_c('icon-line-box', {
    attrs: {
      "icon": "/images/sub/distributor/oring/oring-icon1.png",
      "iconWidth": "49",
      "num": "01"
    }
  }, [_vm._v(" 소재 선택의 폭이 매우 넓음 ")]), _c('icon-line-box', {
    attrs: {
      "icon": "/images/sub/distributor/oring/oring-icon2.png",
      "iconWidth": "50",
      "num": "02"
    }
  }, [_vm._v(" 주문에 따른 최적의 디자인을 적용 ")]), _c('icon-line-box', {
    attrs: {
      "icon": "/images/sub/distributor/oring/oring-icon3.png",
      "iconWidth": "49",
      "num": "03"
    }
  }, [_vm._v(" 모든 분야에 고무 O-Ring (EPDM, Silicon, FKM) 과 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" Metal O-Ring 공급 가능 ")]), _c('icon-line-box', {
    attrs: {
      "icon": "/images/sub/distributor/oring/oring-icon4.png",
      "iconWidth": "50",
      "num": "04"
    }
  }, [_vm._v(" 제품 라인에 폭넓은 산업 분야에 대응 가능 ")])], 1)], 1)], 1)], 1), _c('section', {
    staticClass: "sub-section"
  }, [_c('v-container', [_c('sub-line-layout', {
    attrs: {
      "tit": "Mitsubishi O-Ring",
      "className": "full"
    }
  }, [_c('v-row', {
    staticClass: "my-n10 my-lg-n40"
  }, [_c('v-col', {
    staticClass: "py-10 py-lg-40",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('image-detail', {
    attrs: {
      "tit": "Metal O-ring",
      "src": "/images/sub/distributor/oring/oring-img3-1.png"
    }
  }, [_c('p', {
    staticClass: "font-size-14 font-size-lg-16 color-grey-2c mt-4 mt-lg-10 mb-4 mb-lg-20"
  }, [_vm._v(" 고온, 고압 등과 같은 가혹조건에서MITSUBISHI CABLE Metal O-ring 은 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 극한의 환경 조건인 고 진공 및 극 저온에서 높은 씰링 및 특성을 유지합니다. ")]), _c('p', {
    staticClass: "bar-txt font-size-14 font-size-lg-16 color-grey-2c mb-2 mb-lg-8"
  }, [_vm._v(" - 270 °C ~ +700 °C에서 사용 가능 ")]), _c('p', {
    staticClass: "bar-txt font-size-14 font-size-lg-16 color-grey-2c"
  }, [_vm._v(" - 초고진공 (1.3×10-10Pa) 및 초고압에서 꾸준한 밀봉 성능 : 300MPa (약 3000kgf /cm2) ")])])], 1), _c('v-col', {
    staticClass: "py-10 py-lg-40",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('image-detail', {
    attrs: {
      "tit": "Rubber Seal",
      "src": "/images/sub/distributor/oring/oring-img3-2.png"
    }
  }, [_c('p', {
    staticClass: "font-size-14 font-size-lg-16 color-grey-2c mt-4 mt-lg-10"
  }, [_vm._v(" 많은 고무 sealing을 제조 / 공급 한 통합 sealing 재료 제조업체로서, 우리는 오랜 경험, 풍부한 재료 및 독특하고 최적의 형상 설계 기능을 최상의 혼합을 통해 다양한 조건에 부합하는 제품을 제공합니다. ")])])], 1)], 1)], 1)], 1)], 1), _c('div', {
    staticClass: "sub-section sub-section--last"
  }, [_c('v-container', [_c('inquiry', {
    attrs: {
      "src": "/images/sub/distributor/oring/oring-img1.png",
      "name": "유 동현",
      "tel": "031-765-2268",
      "mail": "davidyoo@ist-co.kr",
      "fax": "031-765-2389",
      "link": "https://www.mitsubishi-cable.co.jp/en/products/group/seal/index.html",
      "linkBg": "/images/sub/distributor/oring/oring-img2.png"
    }
  })], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }